import React, { createContext, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommunityComposeDialog from '../components/community/CommunityComposeDialog';

const CommunityComposerContext = createContext(null);

export function CommunityComposerProvider({ children }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [initialKind, setInitialKind] = useState('discussion');

  const api = useMemo(() => {
    return {
      openComposer: (kind = 'discussion') => {
        setInitialKind(kind);
        setOpen(true);
      },
      closeComposer: () => setOpen(false),
      isOpen: open,
    };
  }, [open]);

  return (
    <CommunityComposerContext.Provider value={api}>
      {children}
      <CommunityComposeDialog
        open={open}
        onOpenChange={setOpen}
        initialKind={initialKind}
        onNavigate={(to) => navigate(to)}
      />
    </CommunityComposerContext.Provider>
  );
}

export function useCommunityComposer() {
  const ctx = useContext(CommunityComposerContext);
  if (!ctx) {
    throw new Error('useCommunityComposer must be used within CommunityComposerProvider');
  }
  return ctx;
}
